import React, { useMemo, useState } from "react"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import PropTypes from "prop-types"
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown"

const UNITY_OPTIONS = {
  default: ["pa", "m", "ml", "m²", "m³", "ud", "kg", "t"],
  desglose: ["l", "h"],
  coste: ["%"],
}

const UnityDropdown = ({ unity, setUnity, imDesglose, type }) => {
  const [menu, setMenu] = useState(false)

  const optionsToShow = useMemo(() => {
    if (type === "coste") {
      return UNITY_OPTIONS.coste
    }
    let baseOptions = [...UNITY_OPTIONS.default]
    if (imDesglose) {
      baseOptions = baseOptions.concat(UNITY_OPTIONS.desglose)
    }
    return baseOptions
  }, [type, imDesglose])

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="d-inline-block"
      style={{ marginTop: "0px" }}
    >
      <DropdownToggle
        className="inline"
        id="settingb"
        style={{
          color: "#414141",
          margin: "0px",
          padding: "0px",
          width: "100%",
          fontWeight: "400",
        }}
      >
        <p
          style={{
            color: "#414141",
            textTransform: "none",
            marginLeft: "15px",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {unity}{" "}
          <KeyboardArrowDown
            style={{
              color: "#414141",
              fontWeight: "400",
              width: "15px",
              marginTop: "-2px",
            }}
          />
        </p>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end" style={{ margin: "0px 0px" }}>
        {optionsToShow.map(opt => (
          <DropdownItem
            key={opt}
            tag="b"
            style={{ cursor: "pointer" }}
            onClick={() => setUnity(opt)}
          >
            <i
              style={{ marginTop: "-2px", paddingRight: "5px" }}
              className="bx bx-list-check font-size-16 align-middle me-1"
            />
            {opt}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

UnityDropdown.propTypes = {
  unity: PropTypes.string,
  setUnity: PropTypes.func,
  imDesglose: PropTypes.bool,
  type: PropTypes.string,
}

export default UnityDropdown
